import { defaultsDeep } from 'lodash'
import { useCallback, useMemo } from 'react'
import type { TrackEventParams, TrackBasicParams } from '@/services/track'
import { track } from '@/services/track'
import { useSelector } from '@/store'
/**
 * 场景映射
 */
export const MERGE_ORDER_TRACK_STAGE = {
  manualCreat: '手动合单',
  autoCreate: '智能合单',
  viewAuto: '查看智能合单预合单',
} as const

/** 地址拆分算法埋点 */
export const useMergeOrderTrack = () => {
  const seller_id = useSelector((state) => state.auth.userInfo?.sellerId)
  const baseTrackData = useMemo(() => {
    return {
      /** 操作端类型 */
      aa_optype: 'PC',
      /** 调用来源 */
      aa_region: 'OW',
      /** 商家 ID */
      seller_id,
      /** 唯一 ID */
      aa_uid: seller_id,
    } as const
  }, [seller_id])

  type MergeOrderSumitParam = Omit<TrackEventParams['mergeOrderSumit'], keyof typeof baseTrackData | keyof TrackBasicParams>

  /** 预合单执行合单上报 */
  const mergeOrderTrack = useCallback(
    async (params: Partial<MergeOrderSumitParam>) => {
      const data: Partial<TrackEventParams['mergeOrderSumit']> = {
        ...baseTrackData,
        ...params,
      }

      await track('mergeOrderSumit', defaultsDeep({}, data, baseTrackData))
    },
    [baseTrackData]
  )

  type MergeOrderSumitResultParams = Omit<TrackEventParams['mergeOrderSumitResult'], keyof typeof baseTrackData | keyof TrackBasicParams>

  /** 合单结果上报 */
  const mergerOrderResultTrack = useCallback(
    async (params: MergeOrderSumitResultParams) => {
      const data: Partial<TrackEventParams['mergeOrderSumitResult']> = {
        ...baseTrackData,
        ...params,
      }

      await track('mergeOrderSumitResult', defaultsDeep({}, data, baseTrackData))
    },
    [baseTrackData]
  )

  return { mergeOrderTrack, mergerOrderResultTrack }
}
